export const AUDIT_FIELD_CATEGORY_UNCATEGORIZED = 'UNCATEGORIZED';

export const AUDIT_FIELD_CATEGORIES = Object.freeze([
    'REPROCESSING',
    'ENVIRONMENTAL',
    'ROUTINE_PRACTICE',
    'OCCUPATIONAL_HEALTH',
]);

export const AUDIT_FIELD_CATEGORY_OPTIONS = Object.freeze([
    { label: 'Reprocessing', value: 'REPROCESSING' },
    { label: 'Environmental', value: 'ENVIRONMENTAL' },
    { label: 'Routine Practice', value: 'ROUTINE_PRACTICE' },
    { label: 'Occupational Health', value: 'OCCUPATIONAL_HEALTH' },
]);

export function normalizeAuditFieldCategory(category) {
    const normalized = String(category ?? '')
        .trim()
        .toUpperCase()
        .replaceAll('-', '_')
        .replaceAll(' ', '_');

    return AUDIT_FIELD_CATEGORIES.includes(normalized)
        ? normalized
        : AUDIT_FIELD_CATEGORY_UNCATEGORIZED;
}

export function isCanonicalAuditFieldCategory(category) {
    return AUDIT_FIELD_CATEGORIES.includes(category);
}
